import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SnackbarProvider, Snackbar } from '@castandcrew/platform-ui';

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: 0 } },
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <SnackbarProvider
        position="bottom right"
        renderToast={(toast) => <Snackbar toast={toast} />}
      >
        <App />
      </SnackbarProvider>
    </BrowserRouter>
  </QueryClientProvider>
);
